export default "__VITE_ASSET__BVC4AmCr__"